import LabelValueLayout from './LabelValueLayout';
export * from './LabelValueLayout';
export default LabelValueLayout;